import { type VariantProps, cva } from "class-variance-authority";
import { type HTMLAttributes, forwardRef } from "react";
import { cn } from "../lib/cn";

export const badgeVariants = cva(
	"inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-primary text-primaryForeground hover:bg-primary/80",
				secondary:
					"border-transparent bg-secondary text-secondaryForeground hover:bg-secondary/80",
				destructive:
					"border-transparent bg-destructive text-destructiveForeground hover:bg-destructive/80",
				outline: "text-foreground",
				success:
					"border-transparent bg-statusSuccess text-primaryForeground hover:bg-statusSuccess/80",
				warning:
					"border-transparent bg-statusWarning text-foreground hover:bg-statusWarning/80",
				info: "border-transparent bg-statusInfo text-primaryForeground hover:bg-statusInfo/80",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

export interface BadgeProps
	extends HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof badgeVariants> {}

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
	({ className, variant, ...props }, ref) => (
		<span
			ref={ref}
			className={cn(badgeVariants({ variant }), className)}
			{...props}
		/>
	),
);
Badge.displayName = "Badge";

export default Badge;
export { Badge };
